import {
  CLEAR_EQUEUES_LIST,
  EQUEUE_BOOKING_SUCCESS,
  EQUEUES_LIST_LOADING_FAILED,
  EQUEUES_LIST_LOADING_SUCCESS, SET_CUSTOM_ERROR_MESSAGE,
  SET_DEFAULT_VALUE,
  SET_EXCEPTIONS,
} from "../actions/types";

const defaultState = {
  hasMore: false,
  items: [],
  exceptions: [],
  error: null,
  success: false,
  customErrorMessage: null
};

const updateEqueue = (state = defaultState, action) => {
  if (!state) {
    return {
      ...defaultState,
    };
  }
  switch (action.type) {
    case EQUEUES_LIST_LOADING_SUCCESS:
      return {
        ...state.equeues,
        hasMore: action.payload.hasMore,
        items: action.payload.items,
        exceptions: action.payload.exceptions,
        error: null,
      };
    case EQUEUES_LIST_LOADING_FAILED:
      return {
        ...state.equeues,
        hasMore: false,
        items: [],
        error: action.payload,
      };
    case EQUEUE_BOOKING_SUCCESS:
      return {
        ...state.equeues,
        success: true,
      };
    case SET_EXCEPTIONS:
      return {
        ...state.equeues,
        exceptions: action.payload,
      };

    case SET_CUSTOM_ERROR_MESSAGE:
      return {
        ...state.equeues,
        customErrorMessage: action.payload,
      };
    case CLEAR_EQUEUES_LIST:
      return defaultState;
    case SET_DEFAULT_VALUE:
      return {
        ...defaultState,
      };

    default:
      return {
        ...state.equeues,
      };
  }
};

export default updateEqueue;
